module.exports = __webpack_public_path__ + "img/edasneo.369b0056.webp";